import { useMemo } from 'react';
import { useThemeMode } from '../contexts/ThemeContext';
import { type DesignTokens, darkTokens, lightTokens } from '../theme/designTokens';

/**
 * 現在のテーマ (light/dark) に応じたデザイントークンを返すフック。
 *
 * 使い方:
 *   const t = useThemeColors();
 *   <Box sx={{ color: t.ink, borderColor: t.line, ... }} />
 *
 * これにより各コンポーネントの `themeMode === 'dark' ? ... : ...` ハードコードを
 * 段階的にトークン参照へ置き換え、ライト/ダーク両対応を担保する。
 */
export const useThemeColors = (): DesignTokens => {
  const { themeMode } = useThemeMode();
  return useMemo(() => (themeMode === 'dark' ? darkTokens : lightTokens), [themeMode]);
};

export default useThemeColors;
